import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-extraneous-dependencies
import { registerField } from 'core/forms';

import { Select } from 'uikit/selects';

import styles from '../styles/formFieldSelect.module.scss';

const FormFieldSelect = ({ fieldId, schema = {}, updateField = () => {}, value = '' }) => {
  const { options, selectProps } = schema;

  return (
    <Select
      ariaLabel={schema.ariaLabel}
      className={classnames(styles.element, selectProps?.isFullWidth && styles.isFullWidth)}
      inputId={fieldId}
      isAsync={schema.isAsync}
      isDisabled={schema.isDisabled}
      onChange={(option) => updateField(option?.value ?? '')}
      options={options}
      value={options?.find((option) => option.value === value)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...selectProps}
    />
  );
};

FormFieldSelect.propTypes = {
  fieldId: PropTypes.string.isRequired,
  schema: PropTypes.shape({
    ariaLabel: PropTypes.string,
    isAsync: PropTypes.bool,
    isDisabled: PropTypes.bool,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
      }),
    ),
    selectProps: PropTypes.shape({}),
  }),
  updateField: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
};

registerField('Select', React.memo(FormFieldSelect));

export default FormFieldSelect;
